import authService from '../services/authService';

// Function to create a test user (for development/testing purposes)
export async function createTestUser(email = 'admin@bioedge.com', password = 'admin123') {
  try {
    console.log('🔐 Creating test user...');
    
    const result = await authService.register(email, password);
    
    if (result.success) {
      console.log('✅ Test user created successfully:', result.user.email);
      return {
        success: true,
        message: `Test user created: ${email}`,
        user: result.user
      };
    } else {
      console.log('⚠️ User might already exist or error occurred:', result.error);
      return {
        success: false,
        message: result.error,
        error: result.error
      };
    }
  } catch (error) {
    console.error('❌ Error creating test user:', error);
    return {
      success: false,
      message: 'Failed to create test user',
      error: error.message
    };
  }
}

// Function to test login with test user
export async function testLogin(email = 'admin@bioedge.com', password = 'admin123') {
  try {
    console.log('🔐 Testing login...');
    
    const result = await authService.login(email, password);
    
    if (result.success) {
      console.log('✅ Login successful:', result.user.email);
      return {
        success: true,
        message: 'Login successful',
        user: result.user
      };
    } else {
      console.log('❌ Login failed:', result.error);
      return {
        success: false,
        message: result.error,
        error: result.error
      };
    }
  } catch (error) {
    console.error('❌ Error during login test:', error);
    return {
      success: false,
      message: 'Login test failed',
      error: error.message
    };
  }
}

// Make functions available globally for console access
if (typeof window !== 'undefined') {
  window.createTestUser = createTestUser;
  window.testLogin = testLogin;
  
  console.log('🔧 Test user utilities available:');
  console.log('  - createTestUser(email, password)');
  console.log('  - testLogin(email, password)');
  console.log('');
  console.log('💡 Example usage:');
  console.log('  createTestUser("admin@bioedge.com", "admin123")');
  console.log('  testLogin("admin@bioedge.com", "admin123")');
} 